import { OrgState } from '../../types';

const state: OrgState = {
  logoUrl: '',
  name: '',
  shortname: '',
};

export default state;
